import React from 'react';
import { IIconProps } from './IIconProps';

export const SearchIcon = ({ iconClass = '', title = '', onClick }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 18 18"
			className={`stroke ${iconClass}`}
			fill="none"
			onClick={onClick}
		>
			{title && <title>{title}</title>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.65039 14.4C11.3783 14.4 14.4004 11.3779 14.4004 7.65002C14.4004 3.9221 11.3783 0.900024 7.65039 0.900024C3.92247 0.900024 0.900391 3.9221 0.900391 7.65002C0.900391 11.3779 3.92247 14.4 7.65039 14.4Z"
			/>
			<path d="M17.0999 17.1L12.4199 12.42" />
		</svg>
	);
};
